module.exports = __webpack_public_path__ + "static/media/uzerpass.1d0dcc83.png";